import * as React from 'react'
import Svg, { Circle, SvgProps } from 'react-native-svg'

export const OptionsMenu = (props: SvgProps) => (
  <Svg viewBox='0 0 20 5' {...props}>
    <Circle cx='2.5' cy='2.5' r='2.5' fill='currentColor' />
    <Circle cx='10' cy='2.5' r='2.5' fill='currentColor' />
    <Circle cx='17.5' cy='2.5' r='2.5' fill='currentColor' />
  </Svg>
)
